module.exports = __webpack_public_path__ + "img/ico_badge15.9ae38f54.svg";